import React from 'react';
import { Icon } from '@web-chat-core/ui-kit';
import { RaiseHandListIconWrapper } from './view';

export const RaiseHandListIcon = () => {
    return (
        <RaiseHandListIconWrapper>
            <Icon icon="icHandUp" size={16} />
        </RaiseHandListIconWrapper>
    );
};
